import { Helmet } from "react-helmet";
import "moment-duration-format";
import React from "react";
import profileImg from "../../assets/images/profile.png";
import LivestreamPage from "../common/LivestreamPage";
import "./style.scss";

function BasicsTraining() {
  const schedules = [
    {
      day: "Every Wednesday",
      time: "Time: 12:00pm EST",
    },
  ];

  return (
    <div className="container-xl-live">
      <Helmet>
        <title>{"Live Training"} | TradeAlgo</title>
      </Helmet>

      <LivestreamPage
        eventID="2824812"
        videoKey="basic-training"
        authorName="Dane Glisek"
        authorTitle="TradeAlgo Analyst"
        authorAvatar={profileImg}
        contentTitle="Group Training Sessions"
        contentDescription="These group training sessions are designed to explain how to take full advantage of the alerts Trade Algo has to offer."
        showSchedule={true}
        schedules={schedules}
        scheduleTitle="LIVE Schedule"
        scheduleStatus="LIVE Schedule"
        scheduleReplayMsg="Replays are available at anytime."
        showPreviousVideos={true}
        customPageSize={19}
        className="basics-training-page"
      />
    </div>
  );
}

export default BasicsTraining;
